var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-x",
    clipPath: "url(#clip0_4764_17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 15.3327C3.94999 15.3327 0.666748 12.0494 0.666748 7.99935C0.666748 3.94926 3.94999 0.666016 8.00008 0.666016C12.0502 0.666016 15.3334 3.94926 15.3334 7.99935C15.3334 12.0494 12.0502 15.3327 8.00008 15.3327ZM8.00008 13.9993C11.3138 13.9993 14.0001 11.3131 14.0001 7.99935C14.0001 4.68564 11.3138 1.99935 8.00008 1.99935C4.68637 1.99935 2.00008 4.68564 2.00008 7.99935C2.00008 11.3131 4.68637 13.9993 8.00008 13.9993ZM8.00008 8.94216L5.80482 11.1374L4.86201 10.1946L7.05727 7.99935L4.86201 5.80409L5.80482 4.86128L8.00008 7.05654L10.1953 4.86128L11.1382 5.80409L8.94289 7.99935L11.1382 10.1946L10.1953 11.1374L8.00008 8.94216Z",
    fill: "#C14141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4764_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleX);
export default __webpack_public_path__ + "static/media/circle-x.e4df21ee126e7854fc0237229c152447.svg";
export { ForwardRef as ReactComponent };